/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';

  app.CartItemView = app.ItemView.extend({
    el: '.catalog__item',
    events: {
      'click .fav-add': 'toggleInFavorites',
      'click .catalog__item-main, .catalog__item-checkbox input': 'toggleCheck',
      'click .js-show-analogs': 'handleToggleAnalogs',
      'click .js-show-analogs-close': 'toggleAnalogs',
      'click .js-remove-from-cart': 'removeFromCart',
      'mouseenter .catalog__item-preview': 'showImagePreview',
      'click .js-add-to-min-real-qty': 'handleAddToMinRealQty',
      'click .js-add-to-waiting-list': 'handleAddToWaitingList',
    },

    inWish: false,
    selected: false,

    /** @inheritDoc */
    run: function () {
      /**
       * Исключаем возможность повторного добавления в корзину с виджета РР.
       */
      if (!this.model.get('item')) {
        this.remove();
        return;
      }
      var wishItemData = this.model.get('wish_item');
      if (wishItemData && _.isObject(wishItemData)) {
        this.wishItem = new app.WishItem(wishItemData);
        app.wish.add(this.wishItem, {silent: true});
      }
      this.perishableTooltip();
      this.listenTo(this.model, 'destroy', this.remove);
      this.initItemDelivery();
      this.template = app.helpers.TemplateHelper.getTemplate('#cart-content');
    },

    /**
     * Хендлер добавления до min qty для сборки
     */
    handleAddToMinRealQty: function () {
      if (app.isMobile && this.childViews.qtyView) {
        this.childViews.qtyView.addToMinRealQty();
      }
    },

    initDom: function () {
      this.checkbox = this.$('input[type=checkbox]');
      this.$favBtn = this.$('.fav-add');
      var item = new app.Item();
      item.set(this.model.get('item'));
      item.set('id', this.model.get('item_id'));
      if (this.childViews.qtyView) {
        this.childViews.qtyView.remove();
      }
      this.childViews.qtyView = new app.CartItemQtyView({
        el: this.$('.qty-wrapper'),
        model: this.model,
        item: item,
        cart: this.cart,
        itemView: this,
        settlement: this.settlement,
        user: this.user,
        currency: this.currency,
        isMobile: app.isMobile,
      });
      this.listenTo(this.childViews.qtyView, 'remove-cart-item', this.remove);
      this.listenTo(this.childViews.qtyView, 'update-on-sync', this.renderRetailFeeMarkupCost);
      this.listenTo(app.wish, 'add update', this.updateWish);
      this.updateWish();
      this.setSpecialOfferTimer();
      if (!app.isMobile) {
        this.childViews.imagePreview = new app.ImagePreviewView({el: this.$('.hint-preview'), model: item});
      }
      this.addRating(this.model.get('item'));
      if (app.isMobile) {
        this.initMobilePopup();
      }
    },

    /**
     * Инициализация попапа на мобильной версии.
     */
    initMobilePopup: function () {
      var $popup = this.$('.js-dialog-cart-item-popup');
      this.childViews.dialogPopup = new app.MobileCartDialogPopup({
        el: $popup,
        dialogPopUp: new als.Popup($popup, this.$('.js-opener-dialog-item-popup'), false, false),
        cartItemView: this,
      });
    },

    /**
     * Удаление товара из корзины.
     */
    removeFromCart: function () {
      if (this.childViews.qtyView) {
        this.childViews.qtyView.removeFromCart();
      }
    },

    showImagePreview: function () {
      if (this.childViews.imagePreview) {
        this.childViews.imagePreview.render(true);
      }
    },

    updateWish: function () {
      this.wishItem = app.wish.get(this.model.get('item_id'));
      this.inWish = this.wishItem !== undefined;
      if (this.inWish) {
        this.$favBtn.removeClass('with-icon_favs-grey ctl-hidden')
          .addClass('added with-icon_favs-red');
      } else {
        this.$favBtn.removeClass('added with-icon_favs-red')
          .addClass('with-icon_favs-grey ctl-hidden');
      }
    },

    render: function () {
      var modelJSON = this.model.toJSON(),
        item = modelJSON.item,
        hasCustomUnits = _.get(modelJSON, 'item.has_custom_qty_units'),
        hasDiscount= _.get(modelJSON, 'item.has_discount'),
        isInWaitingList = _.get(modelJSON, 'item.is_in_waiting_list'),
        price = modelJSON.price,
        minSumForFreeDelivery = _.get(modelJSON, 'item.min_sum_for_free_delivery'),
        priceOld = modelJSON.price_max;
      if (!modelJSON.item) {
        modelJSON.item = {
          img: 'https://stnew.sima-land.ru/items/default/140.jpg'
        };
      }
      if (modelJSON.badges) {
        modelJSON.item.badges = modelJSON.badges;
      }
      var nestedUnitName = item.nestedUnit;
      if (item && hasCustomUnits) {
        var inSet = item.in_set;
        price = app.helpers.NumberHelper.roundFloatPointNum(price / inSet);
        priceOld = app.helpers.NumberHelper.roundFloatPointNum(priceOld / inSet);
      }
      if (item && item.is_weighted_goods) {
        price = price * 10;
        priceOld = priceOld * 10;
        hasCustomUnits = true;
        nestedUnitName = 'кг';
      }
      var element = $(this.template({
        price: app.helpers.NumberHelper.numberWithoutZeroFraction(price),
        priceOld: app.helpers.NumberHelper.numberWithoutZeroFraction(priceOld),
        cartItem: modelJSON,
        currencySign: app.currentCurrency.sign,
        model: modelJSON.item,
        hasCustomUnits: hasCustomUnits,
        hasDiscount: hasDiscount,
        nestedUnitName: nestedUnitName,
        isRemoteStoreWithTooltip: this.model.get('is_small_wholesale_available'),
        minSumForFreeDelivery: app.helpers.NumberHelper.fractionNumber(minSumForFreeDelivery)[0],
        item3dModelFile: this.get3dModelFile(),
        isInWaitingList: isInWaitingList,
        isNewBadgeColors: app.features && app.features.is_new_badge_colors,
      }));
      this.setElement(element);
      this.initDom();
      if (this.childViews.qtyView && this.childViews.qtyView.render) {
        this.childViews.qtyView.render({controls: [false, false]});
        this.renderRetailFeeMarkupCost(this.childViews.qtyView.item);
      }
      this.perishableTooltip();
      return this;
    },

    /**
     * Является ли аналог открытым
     */
    isOpenedAnalog: function () {
      if (this.cart.openedAnalogIds.indexOf(this.model.get('item_id')) !== -1) {
        this.toggleAnalogs();
      }
    },

    /**
     * Хендлер открытия аналогов
     * @param {Event} e - событие клика по кнопке открытия.
     */
    handleToggleAnalogs: function (e) {
      e.stopPropagation();
      if (!this.analogsModel) {
        this.createAnalogsModel();
        if (!this.childViews.loader) {
          this.initLoader();
        }
        this.childViews.loader.render();
        this.listenTo(this.analogsModel, 'sync', this.addAnalogs);
        this.analogsModel.fetch();
      } else {
        this.toggleAnalogs();
      }
    },

    /**
     * Создание модели аналогов.
     */
    createAnalogsModel: function () {
      this.analogsModel = new app.PersonalRecommendations(null, {
        requestParameters: {
          product_sid: this.model.get('item_sid'),
          type: app.CACHE_TYPE_RELATED_LIST,
          expand: 'cart_item',
        }
      });
    },

    /**
     * Получение аналогов.
     */
    addAnalogs: function () {
      var items = this.analogsModel.get('items');
      if (items && items.length) {
        this.initAnalogViews(this.analogsModel);
        if (!app.isMobile && this.cart.isSavedAnalogStates) {
          var isHidden = this.$('.catalog__item-main').hasClass('not_display'),
            itemId = this.analogsModel.get('item_id');
          this.cart.changeOpenedAnalogId(isHidden, itemId);
        }
        this.toggleAnalogs();
        this.childViews.analogsView.trigger('showAnalogs');
      } else {
        this.$('.js-show-analogs').addClass('not_display');
        this.$('.js-analogs-not-found').removeClass('not_display');
      }
      this.childViews.loader && this.childViews.loader.remove();
    },

    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader = new app.LoaderView({
        contentWrapper: this.$el,
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
    },

    /**
     * Добавление вью для аналогов отсутствующих товаров
     */
    initAnalogViews: function (model) {
      var View = app.isMobile
        ? app.MobileCartItemAnalogsView
        : app.PersonalRecommendationsCartAnalogView;
      this.childViews.analogsView = new View({
        model: model,
        algo: 'sima_rs_test_4',
        el: this.$el,
        cart: this.cart,
        cartItem: this.model,
        mainWindow: this.mainWindow,
        bodyView: this.bodyView,
      });
      if (this.cart.isSavedAnalogStates) {
        this.isOpenedAnalog();
      }
    },

    /**
     * Показать/скрыть аналоги товара, которого нет в наличии.
     */
    toggleAnalogs: function () {
      if (!app.isMobile) {
        this.$('.recommendations-cart-analog-container').toggleClass('not_display');
        this.$('.recommendations-cart-analog-header').toggleClass('not_display');
        this.$('.catalog__item-checkbox').toggleClass('not_display');
        this.$('.catalog__item-main').toggleClass('not_display');
      } else {
        this.childViews.analogsView.render();
      }
    },

    toggleInFavorites: function () {
      var that = this;
      if (!app.user.id) {
          app.helpers.CookieHelper.setCookie('wishesAfterLogin', [that.model.get('item_id')], {
            domain: '.' + app.helpers.UrlHelper.getDomain(),
            path: '/',
            expires: 450,
          });
          Backbone.trigger(app.CQC_COMMAND_EVENT, {
            type: app.CQC_COMMAND_TYPES.showAuthForm,
          });
        return;
      }
      this.inWish = app.wish.get(this.model.get('item_id')) !== undefined;
      if (!this.inWish) {
        // добавить товар в избранное
        app.wish.create({
          item_id: that.model.get('item_id')
        }, {
          wait: true,
          method: 'POST'
        });
      } else {
        this.wishItem.destroy({
          url: this.wishItem.url + this.wishItem.get('item_id') + '/',
          wait: true,
          success: function (data) {
            app.wish.remove(data);
          }
        });
      }
    },

    /**
     * Обратный отсчет для спецпредложений.
     */
    setSpecialOfferTimer: function () {
      var $time = this.$('time');
      $time.countdown(new Date($time.attr('data-date'))).on('update.countdown', (function (event) {
        this.$('.days', $time).html(event.strftime('%D'));
        this.$('.hours', $time).html(event.strftime('%H'));
        this.$('.minutes', $time).html(event.strftime('%M'));
        this.$('.seconds', $time).html(event.strftime('%S'));
      }).bind(this));
    },

    /**
     * Инициирует tooltip для товара
     */
    perishableTooltip: function () {
      var jsProp = this.$('.js-item-prop'),
        jsPropWhite = this.$('.js-item-prop-white');
      if (jsProp.length) {
        jsProp.tooltip({
          position: {
            my: 'center bottom-5',
            at: 'center top'
          },
          tooltipClass: 'b-tooltip b-tooltip_abs'
        });
      }
      if (jsPropWhite.length) {
        jsPropWhite.tooltip({
          position: {
            my: 'center bottom-9',
            at: 'center top'
          },
          tooltipClass: 'b-tooltip b-tooltip_abs b-tooltip-white'
        });
      }
    },

    /**
     * @inheritDoc
     */
    renderRetailFeeMarkupCost: function (model) {
      if (app.isMobile) {
        var retailFeeMarkup = model && model.get('retail_fee_markup'),
          hasRetailFeeMarkup = Boolean(retailFeeMarkup && retailFeeMarkup.templates),
          html = '';
        if (hasRetailFeeMarkup) {
          html += this.retailFeeMarkupCostTemplate({
            retailFeeMarkup: retailFeeMarkup,
            grapheme: this.currency.sign,
          });
          var countLabel = retailFeeMarkup.count_label;
          if (retailFeeMarkup.is_added_to_cart) {
            countLabel = this.lessMinQtyTitleTemplate({ countLabel: countLabel });
          }
          countLabel = retailFeeMarkup.templates.lite_title.replace('{count_label}', countLabel);
          html += this.lessMinQtyWrapTemplate({ html: countLabel });
        }
        this.$('.purchase').toggleClass('with-retail-fee-markup', hasRetailFeeMarkup);
        this.$('.mobile-cart-retail-fee-markup').html(html);
      } else {
        app.ItemView.prototype.renderRetailFeeMarkupCost.call(this, model);
      }
    },

    /**
     * Обработчик добавления товара в лист ожидания
     */
    handleAddToWaitingList: function (e) {
      var itemId = this.model.id;
      if (!this.user.id) {
        app.helpers.CookieHelper.setCookie('waitingListAfterLogin', [itemId], {
          domain: '.' + app.helpers.UrlHelper.getDomain(),
          path: '/',
          expires: 450,
        });
        this.redirectToAuth();
        return;
      }
      var prevMessage = this.$(e.currentTarget);
      var successTemplate = app.helpers.TemplateHelper.getTemplate('#waiting-list-message-template');
      !this.childViews.loader && this.initLoader();
      this.childViews.loader.render();
      $.ajax({
        url: app.entryScriptName + '/api/v3/item-waiting-list/',
        type: 'POST',
        data: {
          item_id: itemId,
        },
        success: function () {
          this.model.get('item').is_in_waiting_list = true;
          prevMessage.replaceWith($(successTemplate()));
          this.childViews.loader.remove();
        }.bind(this)
      });
    },
  });
  _.extend(app.CartItemView.prototype, app.ItemInViewPortMixin);
})(jQuery);

}.call(window));